import "./scss/newsletter-via-evangelica.scss"

import { Form } from "../../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../../types/widget.props"

export function WidgetViaEvangelica({ lojaNome, configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    return (
        <div className="container">
            <div className="newsletter-container news-area clearfix">
                <div className="text-container">
                    <h3 className="section-title">Cadastre seu email para receber ofertas exclusivas da {lojaNome}!</h3>              
                </div>
                <div className="input-container">
                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        dinformname="newsletter-widget-via-evangelica"
                        hasFieldTelefone
                        className={{
                            form: "clearfix justify-center",
                            nome: "input-name",
                            email: "input-mail",
                            telefone: "input-phone",
                            button: "button button-smaller button-default"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default class WidgetViaEvangelicaApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetViaEvangelica {...props} />)
    }
}